var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.881 2.705h10.237c.855 0 1.549.716 1.549 1.596v1.762c0 .647-.388 1.445-.775 1.844l-3.336 3.042c-.467.399-.774 1.197-.774 1.844v3.44c0 .482-.307 1.116-.694 1.363l-1.081.702c-1.015.647-2.403-.082-2.403-1.362v-4.24c0-.564-.307-1.28-.627-1.678L4.027 7.81c-.387-.386-.694-1.115-.694-1.597v-1.83c0-.964.694-1.68 1.548-1.68Z",
    fill: "#0D3A80"
  })));
};

export default SvgFilterIcon;